<ion-header class="ion-padding ion-no-border" [ngStyle]="{ display: TOHIDE ? 'none' : 'block' }">
  <ion-toolbar>
    @if (shouldShowBackButton) {
      <ion-buttons slot="start">
        <ion-back-button text="" icon="arrow-back" defaultHref="/home" color="white"></ion-back-button>
      </ion-buttons>
    }

    <ion-label class="ion-text-wrap ion-text-uppercase" color="light">{{ TITLE }}</ion-label>
  </ion-toolbar>
</ion-header>
